import React from 'react';
import { motion } from 'framer-motion';
import { Home, Users } from 'lucide-react';
import { animations } from '../animations';
import { 
  Header,
  Body,
  VehicleCard,
  ButtonGroup,
  Button 
} from '../StyledComponents';

export const HomeCareServiceStep = ({
  availableServices,
  selectedService,
  onServiceSelect,
  onPrevious,
  onNext
}) => {
  const getServiceIcon = (serviceName) => {
    if (serviceName?.toLowerCase().includes('gp')) return '👨‍⚕️';
    if (serviceName?.toLowerCase().includes('nursing')) return '👩‍⚕️';
    if (serviceName?.toLowerCase().includes('dressing')) return '🏥';
    return '🏠';
  };

  return (
    <motion.div {...animations.pageTransition}>
      <Header>
        <Home />
        <h2>Select Home Care Service</h2>
      </Header>
      <Body>
        <p style={{ marginBottom: '2rem', color: '#64748b', textAlign: 'center' }}>
          Choose the type of home care service you need. All services are for 60 minutes.
        </p>

        <div className="service-list">
          {availableServices.map(service => (
            <VehicleCard key={service.vehicleTypeId}>
              <label>
                <input
                  type="radio"
                  name="homeCareService"
                  checked={selectedService?.vehicleTypeId === service.vehicleTypeId}
                  onChange={() => onServiceSelect(service)}
                />
                <div className="details">
                  <h4 style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ fontSize: '1.5rem' }}>
                      {getServiceIcon(service.serviceName)}
                    </span>
                    {service.serviceName}
                  </h4>
                  <p style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    💰 Fixed Price: ${service.fixedPrice} (60 minutes)
                  </p>
                  <p style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <Users size={16} />
                    {service.availableDrivers} provider{service.availableDrivers !== 1 ? 's' : ''} available
                  </p>
                  <small style={{ color: '#16a34a', fontWeight: '500' }}>
                    Professional home care service at your location
                  </small>
                </div>
              </label>
            </VehicleCard>
          ))}
        </div>

        {availableServices.length === 0 && (
          <div style={{
            textAlign: 'center',
            padding: '2rem',
            color: '#64748b'
          }}>
            <Home size={48} style={{ marginBottom: '1rem', opacity: 0.5 }} />
            <p>No home care services are currently available in your area.</p>
            <small>Please try again later or contact support for assistance.</small>
          </div>
        )}

        <ButtonGroup>
          <Button variant="secondary" onClick={onPrevious}>
            Previous
          </Button>
          <Button
            variant="primary"
            onClick={onNext}
            disabled={!selectedService}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            Continue
          </Button>
        </ButtonGroup>
      </Body>
    </motion.div>
  );
};
